import {
  createRoute,
  createRootRouteWithContext,
  ErrorComponent,
  redirect,
} from "@tanstack/react-router";
import { App } from "@/components/App";
import type { rootStore } from "@/store";
import type { Province } from "@/store/types/province";
import { provinceFullNameById } from "@/store/types/province";
import { PageNotFoundPanel } from "@/components/App/PageNotFountPanel";
import { appEnv } from "@/constants/env";
import { telemetry } from "@/telemetry";

interface RouterContext {
  store: typeof rootStore;
}

export const rootRoute = createRootRouteWithContext<RouterContext>()({
  component: App,
  errorComponent: ErrorComponent,
  notFoundComponent: PageNotFoundPanel,
});

export const provinceRoute = createRoute({
  id: "province",
  getParentRoute: () => rootRoute,
  validateSearch: (
    search: Record<string, unknown>,
  ): { province?: Province } => {
    const province = search.province as Province;
    return {
      ...search,
      province: provinceFullNameById[province] == null ? undefined : province,
    };
  },
  beforeLoad: ({ search, context }) => {
    if (search.province && !context.store.activeProvinceId)
      context.store.setActiveProvinceId(search.province);

    return true;
  },
});

export const restrictedRoute = createRoute({
  id: "restricted",
  getParentRoute: () => provinceRoute,
  beforeLoad: ({ context }) => {
    if (!context.store.orderData.isActive) {
      throw redirect({
        to: "/",
      });
    }

    return true;
  },
});

export const adminRoute = createRoute({
  path: "admin",
  getParentRoute: () => rootRoute,
  beforeLoad: (): any => {
    telemetry.trackEvent("admin_redirected", {
      referrer_host: telemetry.getHost(document.referrer),
    });
    telemetry.flush();
    window.location.href = appEnv.adminUrl;
    return false;
  },
});
